import { render, staticRenderFns } from "./xcxOperate.vue?vue&type=template&id=20440fcc&scoped=true"
import script from "./xcxOperate.vue?vue&type=script&lang=js"
export * from "./xcxOperate.vue?vue&type=script&lang=js"
import style0 from "./xcxOperate.vue?vue&type=style&index=0&id=20440fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20440fcc",
  null
  
)

export default component.exports